import { FaSignsPost, FaDiamondTurnRight } from "react-icons/fa6";
import { Container } from "~/components/container";
import { SidebarLinks } from "~/components/sidebar-links";
import { Brochure } from "~/components/brochure";
import Gallery from "~/components/gallery";
import { Hero } from "~/components/hero";
import { Image } from "~/components/Image";

export function ParkTemplate({ page }) {
  const hero = page.acf?.hero;
  const hasGallery = page.acf.gallery && page.acf.gallery.length > 0;
  const addressString = `${page.acf.address.street} ${page.acf.address.city} IL ${page.acf.address.zip}`;
  const directionsUrl = `https://www.google.com/maps/place/${addressString}`;
  return (
    <section>
      {hero && <Hero {...hero} />}
      <Container>
        <div className="grid lg:grid-cols-7">
          <div className="lg:col-span-3 lg:p-10 order-last lg:order-first">
            <div className="sticky top-4 grid gap-6">
              <SidebarLinks links={page.acf.sidebar_menu} />
              <Brochure images={page.acf.options.brochure_images} url={page.acf.options.brochure_url} />
            </div>
          </div>
          <div className="lg:col-span-4 order-first lg:order-last px-6 py-12" data-searchable>
            <h1 className="font-semibold text-5xl flex">{page.title.rendered}</h1>
            <p className="text-2xl pt-1">{page.acf.address.street}</p>
            <div className="flex text-sm opacity-75 gap-2 mt-1" data-no-index>
              <div className="flex items-center">
                <FaSignsPost className="inline mr-2" />
                {page.acf.acres} Acres
              </div>
              <div>|</div>
              <a href={directionsUrl} target="_blank" rel="noopener" className="flex items-center gap-1">
                <FaDiamondTurnRight />
                Get Directions
              </a>
            </div>

            <div className="pt-6" dangerouslySetInnerHTML={{ __html: page.acf.about }}></div>
            <h2 className="text-lg font-semibold mt-12">Amenities</h2>
            {page.amenities?.length > 0 && (
              <div className="flex flex-wrap gap-2 text-xs mt-2">
                {page.amenities.map((amenity) => {
                  return (
                    <div key={amenity.id} className="border px-2 py-1 rounded-md">
                      {amenity.name}
                    </div>
                  );
                })}
              </div>
            )}
            {hasGallery && (
              <section className="mt-12">
                <h2 className="text-3xl font-semibold">Gallery</h2>
                <Gallery images={page.acf?.gallery} />
              </section>
            )}
            <section className="mt-12" data-no-index>
              <h2 className="text-3xl font-semibold">Explore more parks!</h2>
              {page.related_parks.map((park) => {
                return (
                  <a key={park.id} className="flex items-center gap-4 mt-6" href={park.url}>
                    <Image
                      src={park.acf.featured_image?.url}
                      alt={park.acf.featured_image?.alt}
                      className="w-24 h-24 object-cover rounded-md"
                    />
                    <div>
                      <div className="font-semibold">{park.title}</div>
                      <p>{park.acf.address.street}</p>
                    </div>
                  </a>
                );
              })}
            </section>
          </div>
        </div>
      </Container>
    </section>
  );
}
